import { isMobile } from '~/tools/userEnvironment/browser'

const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

const months = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
];
const oneDayInMs = 24 * 60 * 60 * 1000;

const getDayOfTheWeek = epochTimestamp =>
  days[new Date(epochTimestamp).getDay()];

export const getMonth = epochTimestamp =>
  months[new Date(epochTimestamp).getMonth()];

const padZero = num => (num <= 9 ? "0" + num : num);

export const formatStartTime = epochStartTime => {
  const d = new Date(epochStartTime),
    hrs = d.getHours(),
    hours = hrs > 12 ? hrs - 12 : hrs,
    min = d.getMinutes(),
    pd = hrs >= 12 ? "PM" : "AM";
  return `${hours}:${padZero(min)} ${pd}`;
};

const sortByTimestamp = (a, b) =>
  (a.timestamp || a.gist.scheduleStartDate) -
  (b.timestamp || b.gist.scheduleStartDate);

const blankWeekMaker = (weekCount = 1) => {
  let dayStamp = Date.now();
  const output = [];
  while (output.length < weekCount * 7) {
    const day = getDayOfTheWeek(dayStamp),
      month = getMonth(dayStamp),
      date = new Date(dayStamp).getDate(),
      key = day + date,
      timestamp = dayStamp,
      dayObj = { day, date, month, timestamp, key };
    output.push(dayObj);
    dayStamp += oneDayInMs;
  }
  return output.reduce((a, { key, day, date, month, timestamp }) => {
    a[key] = { day, date, month, timestamp };
    return a;
  }, {});
};

export const splitEventsIntoDays = (events = [], weekCount = 1) => {
  const eventsPerDayObject = events.reduce((hash, e) => {
    const timestamp = e.gist.scheduleStartDate,
      day = getDayOfTheWeek(timestamp),
      date = new Date(timestamp).getDate(),
      key = day + date;
      if(hash[key]) {
        if (hash[key].events) {
          hash[key].events.push(e);
        } else {
          hash[key] = { ...hash[key], events: [e] };
        }
      }
    return hash;
  }, blankWeekMaker(weekCount));

  return Object.values(eventsPerDayObject)
    .sort(sortByTimestamp)
    .map(o => {
      const events = o.events ? o.events.sort(sortByTimestamp) : null;
      return {
        day: o.day,
        date: o.date,
        month: o.month,
        events
      };
    });
};

export const daysDifference = (date1, date2) => {
  const msInDay = 24*60*60*1000;
  return Math.abs((date2 - date1)/msInDay);
}

export const CONSTANTS = {
  RIGHT: "right",
  LEFT: "left",
  BOTH: "both",
  NONE: "none"
};
